export default __webpack_public_path__ + "static/media/green-galaxy-landing.24e25f99.jpg";